import { styled } from '@creditas/stylitas'

const ModalFooterStyled = styled.div`
  height: 50px;
  border-radius: 0 0 16px 16px; ;
`

export { ModalFooterStyled }
